import React from "react";
import {
  AlertMessage,
  Button,
  TextField,
  Typography,
  icons,
  theme,
} from "cdh-data-portal-theme";
import { useRetryRequestPage } from "./RetryRequestPage.logic";
import { useStyles } from "./RetryRequestPage.style";
import { localtext } from "./RetryRequestPage.static";

export const RetryRequestPage: React.FC = () => {
  const { classes } = useStyles();
  const {
    handleRetryRequest,
    isSubmitting,
    notice,
    requestId,
    setRequestId,
    setTicketUrl,
    ticketUrl,
  } = useRetryRequestPage();

  return (
    <div className={classes.root}>
      <Typography
        variant="headline1"
        className={classes.title}
        color={theme.textColors.primary}
      >
        {localtext.Title}
      </Typography>
      <Typography
        variant="body"
        className={classes.subtitle}
        color={theme.textColors.primaryLighter}
      >
        {localtext.Subtitle}
      </Typography>
      <div className={classes.form}>
        <div className={classes.fieldRow}>
          <TextField
            label={localtext.RequestId}
            placeholder={localtext.RequestIdPlaceholder}
            value={requestId}
            onChange={(event) => setRequestId(event.target.value)}
          />
          <TextField
            label={localtext.TicketUrl}
            placeholder={localtext.TicketUrlPlaceholder}
            value={ticketUrl}
            onChange={(event) => setTicketUrl(event.target.value)}
          />
        </div>
        {notice && (
          <AlertMessage
            className={classes.feedback}
            message={notice.message}
            title={notice.title}
            variant={notice.variant}
          />
        )}
        <Button
          className={classes.retryButton}
          icon={icons.refresh}
          isLoading={isSubmitting}
          title={localtext.Retry}
          variant="primary"
          onClick={() => void handleRetryRequest()}
        />
      </div>
    </div>
  );
};
